import React from 'react';
import { PaymentSuccess } from '@/components/payment/payment-success';

export default function PaymentSuccessPage() {
    return (
        <div className="container mx-auto px-4 py-8 max-w-2xl">
            <PaymentSuccess />
        </div>
    );
}
